import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.k12_1 = this;
        this.l12_1 = this;
        this.m12_1 = false;
      }
      n12(node, permissionsBitmask) {
        var prev = this.l12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.r1l_1 & permissionsBitmask) === 0 && prev.n12(node, permissionsBitmask));
        } else {
          node.k12_1 = this;
          node.l12_1 = prev;
          prev.k12_1 = node;
          this.l12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      c15(forbiddenElementsBit) {
        this.n12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      o12() {
        if (this.m12_1)
          return false;
        var prev = this.l12_1;
        var next = this.k12_1;
        prev.k12_1 = next;
        next.l12_1 = prev;
        this.m12_1 = true;
        return true;
      }
      p12(node) {
        if (!(this.k12_1 === this))
          return false;
        this.n12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.r1l_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
